import i18next from 'i18next';
import _ from 'lodash';

export const defaultLang = () => {
  switch (_.get(process.env.APP_CONFIG, ['APP_DETAILS', 'EN_NAME'], '')) {
    case 'Filimo':
      return 'fa';
    case 'Filimo School':
      return 'fa';
    case 'Aparat Kids':
      return 'fa';
    case 'Narengi':
      return 'fa';
    case 'Televika':
      return 'fa';
    case 'Zolal':
      return 'en';
    case 'Forsi':
      return 'tj';
    default:
      break;
  }
  return '';
};

export const isRTL = () => {
  const storedLang = localStorage.getItem('lang');
  const lang = (i18next && i18next.language) ? i18next.language.split('-')[0] : storedLang || defaultLang();
  return lang === 'fa' || lang === 'ar';
};

export const langList = () => {
  switch (_.get(process.env.APP_CONFIG, ['APP_DETAILS', 'EN_NAME'], '')) {
    case 'Filimo':
      return ['fa'];
    case 'Filimo School':
      return ['fa', 'en'];
    case 'Aparat Kids':
      return ['fa'];
    case 'Narengi':
      return ['fa', 'en'];
    case 'Televika':
      return ['fa', 'en'];
    case 'Zolal':
      return ['en', 'ar'];
    case 'Forsi':
      return ['tj', 'en'];
    default:
      break;
  }
  return '';
};
